export const alerts = {
	methods : {
		getClosedAlerts () {
			let closed = this.$cookies.get('omapp-closed-alerts')
			if ('string' === typeof closed) {
				try {
					closed = JSON.parse(closed)
				} catch (e) {
					// prevent crash, but ignore message
				}
			}

			return '[object Object]' === toString.call(closed)
				? closed
				: {}
		},
		isClosedAlert (id) {
			const alerts = this.getClosedAlerts()

			return alerts && alerts[id]
		},
		addClosedAlert (id) {
			let closed = this.getClosedAlerts()
			closed[id] = true

			if (this.isBlurbAlert(id)) {
				this.$cookies.create('omapp-closed-blurb', 1, 14, true)
			}

			this.$cookies.create('omapp-closed-alerts', closed)
		},
		isBlurbAlert(id) {
			return 'blurb-' === id.substr(0, 6)
		},
		blurbPrevented(id) {
			return this.isBlurbAlert(id) && this.$cookies.get('omapp-closed-blurb');
		}
	}
}